export default "__VITE_ASSET__CPpTja8K__"